export default __webpack_public_path__ + "static/media/animation-arrow12.99e4bca7.gif";